import React from 'react';
import { Icon } from '@pwc/pwc-deals-ui';
import './index.scss';

const PreviewLoadingError = () => {
  return (
    <section
      className="preview-loading-error"
      data-testid="preview-loading-error"
    >
      <div>
        <Icon className="outline" width="64" name="note-error" />
      </div>
      <div>
        <h1>Preview Error</h1>
      </div>
      <div>
        <h4>There&apos;s problem loading this page</h4>
        <h4>Please go back to the Report Builder and try again</h4>
      </div>
    </section>
  );
};

export default PreviewLoadingError;
